
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_k5dlb_1snsq_149",
  "top-navigation": "awsui_top-navigation_k5dlb_1snsq_163",
  "padding-box": "awsui_padding-box_k5dlb_1snsq_198",
  "medium": "awsui_medium_k5dlb_1snsq_208",
  "narrow": "awsui_narrow_k5dlb_1snsq_208",
  "virtual": "awsui_virtual_k5dlb_1snsq_219",
  "hidden": "awsui_hidden_k5dlb_1snsq_223",
  "\t": "awsui_\t_k5dlb_1snsq_1",
  "identity": "awsui_identity_k5dlb_1snsq_235",
  "identity-link": "awsui_identity-link_k5dlb_1snsq_238",
  "no-logo": "awsui_no-logo_k5dlb_1snsq_258",
  "logo": "awsui_logo_k5dlb_1snsq_262",
  "title": "awsui_title_k5dlb_1snsq_274",
  "inputs": "awsui_inputs_k5dlb_1snsq_289",
  "search": "awsui_search_k5dlb_1snsq_297",
  "search-expanded": "awsui_search-expanded_k5dlb_1snsq_301",
  "utilities": "awsui_utilities_k5dlb_1snsq_305",
  "utility-wrapper": "awsui_utility-wrapper_k5dlb_1snsq_316",
  "utility-type-button-link": "awsui_utility-type-button-link_k5dlb_1snsq_337",
  "utility-type-menu-dropdown": "awsui_utility-type-menu-dropdown_k5dlb_1snsq_342",
  "utility-type-button-primary-button": "awsui_utility-type-button-primary-button_k5dlb_1snsq_351",
  "utility-link-icon": "awsui_utility-link-icon_k5dlb_1snsq_359",
  "utility-button-external-icon": "awsui_utility-button-external-icon_k5dlb_1snsq_363",
  "offset-right-none": "awsui_offset-right-none_k5dlb_1snsq_367",
  "offset-right-l": "awsui_offset-right-l_k5dlb_1snsq_371",
  "offset-right-xxl": "awsui_offset-right-xxl_k5dlb_1snsq_375",
  "overflow-menu-drawer": "awsui_overflow-menu-drawer_k5dlb_1snsq_380",
  "overflow-menu": "awsui_overflow-menu_k5dlb_1snsq_380",
  "overflow-menu-header": "awsui_overflow-menu-header_k5dlb_1snsq_424",
  "overflow-menu-header-text": "awsui_overflow-menu-header-text_k5dlb_1snsq_432",
  "overflow-menu-header-text--secondary": "awsui_overflow-menu-header-text--secondary_k5dlb_1snsq_444",
  "overflow-menu-header-text--title": "awsui_overflow-menu-header-text--title_k5dlb_1snsq_450",
  "overflow-menu-back-button": "awsui_overflow-menu-back-button_k5dlb_1snsq_454",
  "overflow-menu-dismiss-button": "awsui_overflow-menu-dismiss-button_k5dlb_1snsq_458",
  "overflow-menu-control": "awsui_overflow-menu-control_k5dlb_1snsq_462",
  "overflow-menu-list-item-utility": "awsui_overflow-menu-list-item-utility_k5dlb_1snsq_503",
  "overflow-menu-control-link": "awsui_overflow-menu-control-link_k5dlb_1snsq_511",
  "overflow-menu-control-expandable-menu-trigger": "awsui_overflow-menu-control-expandable-menu-trigger_k5dlb_1snsq_514",
  "overflow-menu-list": "awsui_overflow-menu-list_k5dlb_1snsq_503",
  "overflow-menu-list-submenu": "awsui_overflow-menu-list-submenu_k5dlb_1snsq_550",
  "overflow-menu-list-item": "awsui_overflow-menu-list-item_k5dlb_1snsq_503",
  "overflow-menu-list-item-icon": "awsui_overflow-menu-list-item-icon_k5dlb_1snsq_559",
  "overflow-menu-list-item-text": "awsui_overflow-menu-list-item-text_k5dlb_1snsq_562",
  "overflow-menu-list-item-submenu": "awsui_overflow-menu-list-item-submenu_k5dlb_1snsq_571",
  "overflow-menu-list-item-dropdown-menu": "awsui_overflow-menu-list-item-dropdown-menu_k5dlb_1snsq_577",
  "overflow-menu-list-item-expandable": "awsui_overflow-menu-list-item-expandable_k5dlb_1snsq_581",
  "expanded": "awsui_expanded_k5dlb_1snsq_589"
};
  